import React
// , { useState }
 from 'react'
import styled from 'styled-components'
import BackToDash from '../components/BackToDash'
import pdeDiagram from '../img/PDEDiagram.png'

const Styles = {
  Headline: styled.h2`
color: ${({ theme }) => theme.colors.grey4};
margin: 1rem;
text-align: center;
`,
  PageCont: styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
max-width: 800px;
`,
  Table: styled.table`
margin: 1rem;
border: 1px solid black;
border-collapse: collapse;
thead th:nth-child(1) {
  width: 30%;
}
thead th:nth-child(2) {
  width: 70%;
}
th, td {
  padding: 1.5rem;
  border: 1px solid black;
}
`,
  Para: styled.p`
margin: 1rem;
`,
  Diagram: styled.img`
// cursor: ${({ width }) => width === 1346 ? 'zoom-out' : 'zoom-in'};
width: ${({ width }) => width};

`,

}

const About = () => {

  // const initialState = 700

  // const [imgWdth, setImgWdth] = useState(initialState)

  // const handleImgWidth = () => {
  //   if (imgWdth === 1346){
  //     setImgWdth(initialState)
  //   } else {
  //     setImgWdth(1346)
  //   }
  // }

  return (
    <Styles.PageCont>
      <Styles.Headline>
        Welcome to the <u>W</u>etlands <u>A</u>ssessment <u>T</u>ool for <u>C</u>ondition & <u>H</u>ealth (WATCH)
      </Styles.Headline>
      <Styles.Para>
        The goal of WATCH is to provide a method to evaluate the condition and trajectory of a tidal wetland site to inform decision-making, restoration project prioritization, and the selection of restoration tactics.  Watch utilizes a hierarchical structure to guide the user through the evaluation of the current and future states of a suite of attributes, shown to be fundamental in salt marsh function, to gain a holistic understanding of site-specific deficiencies.
      </Styles.Para>
      <Styles.Diagram 
      // onClick={handleImgWidth}
       width={1346}
       src={pdeDiagram} alt='diagram of WATCH workflow' />
      {/* Table of attributes */}
      <Styles.Table>
        <caption>
          WATCH asks the user to provide information regarding the following attributes:
        </caption>
        <thead>
          <tr>
            <th>Attribute</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              Horizontal Position
            </td>
            <td>
              Relative position of the waterward edge of a feature
            </td>
          </tr>
          <tr>
            <td>
              Vertical Position
            </td>
            <td>
              Elevation - can be relative to a vertical or tidal datum
            </td>
          </tr>
          <tr>
            <td>
              Biology
            </td>
            <td>
              Flora and/or fauna of interest
            </td>
          </tr>
          <tr>
            <td>
              Hydrology
            </td>
            <td>
              Water movement
            </td>
          </tr>
          <tr>
            <td>
              Soil Condition
            </td>
            <td>
              Underlying landscape
            </td>
          </tr>
          <tr>
            <td>
              Sediment
            </td>
            <td>
              The availability and effects of particle inputs
            </td>
          </tr>
          <tr>
            <td>
              Water Chemistry
            </td>
            <td>
              Salinity
            </td>
          </tr>

        </tbody>
      </Styles.Table>
      <Styles.Para>
        WATCH guides the user through data entry and interpretation of each functional attribute (horizontal position, vertical position, biology, and hydrology) to gain a more holistic understanding of site-specific salt marsh condition. For these attributes, WATCH evaluates data against user-defined criteria to identify evidence of current and/or future deficiencies. The combination of outcomes is used to identify indicators of overall, site-wide reduced functions. These attribute-specific deficiencies are subsequently integrated to identify unique combinations indicative of overall, site-wide diminished functionality. When the data suggest diminished functionality for one or more attributes, but the evidence is not strong enough to indicate site-wide deficiency, WATCH identifies interrelated attributes for additional, or continued, monitoring.
      </Styles.Para>
      <Styles.Para>
        Additionally, to provide context for the state of the functional attributes, WATCH asks the user to provide information regarding three additional large-scale: soil type, water chemistry, and sediment qualities including availability and relationships with vertical and horizontal positions and decomposing rates. The outcomes of these evaluations are presented in the form of "considerations" that should inform intervention strategies if appropriate.
      </Styles.Para>
      <Styles.Para>
        Finally, a regulatory checklist is provided that includes some requirements for commonly used permits for restoration activities in Delaware and New Jersey. These requirements are aligned with various metrics in some of the attributes and allow the user to identify and compile some information and products required for specific permits that may be sought if the output indicates that an intervention may be appropriate.
      </Styles.Para>

      <Styles.Table>
        <caption>Points of Contact</caption>
        <thead>
          <tr>
            <th>Name</th>
            <th>Title</th>
            <th>Contact Info</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>LeeAnn Haaf, PhD</td>
            <td>Estuary Science Manager</td>
            <td><a href='mailto:lhaaf@delawareestuary.org'>lhaaf@delawareestuary.org</a> or (302) 655-4990 ext.116</td>
          </tr>
          <tr>
            <td>Joshua Moody, PhD</td>
            <td>Research Scientist</td>
            <td><a href='mailto:joshua.moody@dep.nj.gov'>joshua.moody@dep.nj.gov</a></td>
          </tr>
        </tbody>
      </Styles.Table>
      {/* Table of funding */}
      <Styles.Table>
        <caption>Funding for WATCH Provided By:</caption>
        <tbody>
          <tr>
            <td>v 1.0</td>
            <td>
              New Jersey Department of Environmental Protection PO# 8617120, Development of a Site-Based Salt Marsh Decision Tool, to the Partnership for the Delaware Estuary
            </td>
          </tr>
          <tr>
            <td>v 2.0 & 3.0  </td>
            <td>
              National Fish & Wildlife Foundation Delaware Watershed Conservation Fund ID 0403.19.065232, Developing a Site-based Decision Tool for Targeted Implementation of Living Shoreline Strategies (DE, NJ)
            </td>
          </tr>
        </tbody>
      </Styles.Table>
      <BackToDash />

    </Styles.PageCont>
  )
}

export default About